import * as React from "react";
import { experimentalStyled as styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { Container } from "@mui/system";
import { Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : green[600],
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: "white",
  fontSize: "bold",
}));

export default function WhenYouNeedHelp() {
  return (
    <Fade cascade damping={0.1} direction="left">
      <Box
        className="min-h-full"
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#D3D3D3",
          alignItems: "center",
          my: 10,
        }}
      >
        <Container>
          <Typography
            variant="h1"
            component="h2"
            className="text-3xl font-extrabold text-center py-12"
          >
            When do you need help?
          </Typography>

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            className="pb-20"
          >
            <Grid item xs={2} sm={4} md={3}>
              <Item>
                {" "}
                <Link to={"now"}> Now</Link>{" "}
              </Item>
            </Grid>{" "}
            <Grid item xs={2} sm={4} md={3}>
              <Item>
                <Link to={"this_week"}>This week </Link>{" "}
              </Item>
            </Grid>{" "}
            <Grid item xs={2} sm={4} md={3}>
              <Item>
                {" "}
                <Link to={"this_week"}>This Month</Link>
              </Item>
            </Grid>{" "}
            <Grid item xs={2} sm={4} md={3}>
              <Item>
                {" "}
                <Link to={"this_week"}> Not sure yet </Link>
              </Item>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Fade>
  );
}
